import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase';
import ReactPaginate from 'react-paginate';

const JoursFermeture = () => {
    const [fermetures, setFermetures] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newFermeture, setNewFermeture] = useState({ type: 'jour', date: '', date_debut: '', date_fin: '', description: '' });
    const [isPeriod, setIsPeriod] = useState(false);
    const [filter, setFilter] = useState('futurs'); // 'futurs' ou 'passes'

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5; // Nombre d'éléments par page
    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null); // ID de la fermeture à supprimer

    useEffect(() => {
        fetchFermetures();
    }, []);

    const fetchFermetures = async () => {
        const fermeturesCollection = collection(db, 'fermetures');
        const fermeturesSnapshot = await getDocs(fermeturesCollection);
        const fermeturesList = fermeturesSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setFermetures(fermeturesList);
    };

    const handleAddFermeture = async () => {
        const { type, date, date_debut, date_fin, description } = newFermeture;

        if ((type === 'jour' && date) || (type === 'periode' && date_debut && date_fin)) {
            await addDoc(collection(db, 'fermetures'), { type, date, date_debut, date_fin, description });
            setNewFermeture({ type: 'jour', date: '', date_debut: '', date_fin: '', description: '' });
            setShowModal(false);
            fetchFermetures();
        }
    };

    const handleDeleteFermeture = async () => {
        if (deleteId) {
            await deleteDoc(doc(db, 'fermetures', deleteId));
            setShowConfirm(false);
            setDeleteId(null);
            fetchFermetures();
        }
    };

    const filteredFermetures = fermetures.filter(fermeture => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (fermeture.type === 'jour') {
            const fermetureDate = new Date(fermeture.date);
            fermetureDate.setHours(0, 0, 0, 0);
            return filter === 'futurs' ? fermetureDate >= today : fermetureDate < today;
        } else {
            const fermetureFin = new Date(fermeture.date_fin);
            fermetureFin.setHours(0, 0, 0, 0);
            return filter === 'futurs' ? fermetureFin >= today : fermetureFin < today;
        }
    });

    // Logique de pagination
    const indexOfLastItem = (currentPage + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentFermetures = filteredFermetures.slice(indexOfFirstItem, indexOfLastItem);
    const pageCount = Math.ceil(filteredFermetures.length / itemsPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    return (
        <div className="container">
            <h1 className="h3 mb-4 text-gray-800">Gestion des Jours et Périodes de Fermeture</h1>
            <div className='d-flex'>
                <Form.Group controlId="filterSelect" className="mb-3 mr-2">
                    <Form.Control as="select" value={filter} onChange={(e) => {
                        setFilter(e.target.value);
                        setCurrentPage(0); // Réinitialiser la page actuelle lors du changement de filtre
                    }}>
                        <option value="futurs">Fermetures futures</option>
                        <option value="passes">Fermetures passées</option>
                    </Form.Control>
                </Form.Group>
                <Button onClick={() => setShowModal(true)} className="btn-warning mb-4">
                    Ajouter une fermeture
                </Button>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Date / Période</th>
                        <th>Description</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {currentFermetures.map(fermeture => (
                        <tr key={fermeture.id}>
                            <td>{fermeture.type === 'jour' ? 'Jour' : 'Période'}</td>
                            <td>
                                {fermeture.type === 'jour' ? fermeture.date : `${fermeture.date_debut} - ${fermeture.date_fin}`}
                            </td>
                            <td>{fermeture.description}</td>
                            <td>
                                <Button variant="danger" onClick={() => { setShowConfirm(true); setDeleteId(fermeture.id); }}>
                                    Supprimer
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Pagination */}
            <ReactPaginate
                previousLabel={'Précédent'}
                nextLabel={'Suivant'}
                breakLabel={'...'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                activeClassName={'active'}
            />

            {/* Modal pour ajouter une fermeture */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une Fermeture</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="typeSelect">
                            <Form.Label>Type</Form.Label>
                            <Form.Control as="select" value={newFermeture.type} onChange={(e) => {
                                const type = e.target.value;
                                setNewFermeture(prev => ({ ...prev, type }));
                                setIsPeriod(type === 'periode');
                            }}>
                                <option value="jour">Jour</option>
                                <option value="periode">Période</option>
                            </Form.Control>
                        </Form.Group>
                        {isPeriod ? (
                            <>
                                <Form.Group controlId="dateDebut">
                                    <Form.Label>Date de début</Form.Label>
                                    <Form.Control type="date" value={newFermeture.date_debut} onChange={(e) => setNewFermeture(prev => ({ ...prev, date_debut: e.target.value }))} />
                                </Form.Group>
                                <Form.Group controlId="dateFin">
                                    <Form.Label>Date de fin</Form.Label>
                                    <Form.Control type="date" value={newFermeture.date_fin} onChange={(e) => setNewFermeture(prev => ({ ...prev, date_fin: e.target.value }))} />
                                </Form.Group>
                            </>
                        ) : (
                            <Form.Group controlId="date">
                                <Form.Label>Date</Form.Label>
                                <Form.Control type="date" value={newFermeture.date} onChange={(e) => setNewFermeture(prev => ({ ...prev, date: e.target.value }))} />
                            </Form.Group>
                        )}
                        <Form.Group controlId="description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control as="textarea" rows={3} value={newFermeture.description} onChange={(e) => setNewFermeture(prev => ({ ...prev, description: e.target.value }))} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Annuler
                    </Button>
                    <Button variant="primary" onClick={handleAddFermeture}>
                        Ajouter
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Popup de confirmation pour la suppression */}
            <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation de suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer cette fermeture ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={handleDeleteFermeture}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default JoursFermeture;
